module.exports = __webpack_public_path__ + "static/pyramids_alien_drawing1-e664f673d9541ddb5167678c61c37aff.png";